import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const plannedWeaning: BlogMetaData = {
  title: '断乳はいつから？計画的に進める断乳の時期・進め方・胸のケア',
  description:
    '断乳はいつから始める？計画的に授乳をやめる断乳の時期の決め方、数週間かけた進め方とスケジュール、圧抜きなど胸のケア、卒乳との違いまでモンテッソーリの視点でやさしく解説します。',
  thumbnailUrl: '/img/blog-planned-weaning.webp',
  filePath: buildBlogFilePath('planned-weaning'),
  category: BLOG_CATEGORY.PARENTING,
};
